import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { BannerMessage } from 'components';
import useTranslation from 'hooks/useTranslation';
import { replaceKeyWithValue } from 'utils/text';

const mapState = (state) => ({
  remainingDaysNum: state.userData.profile.remainingDaysNum,
  remainingConvsNum: state.userData.profile.remainingConvsNum,
});

const getBannerStatusFromLocalStorage = (bannerName) =>
  localStorage.getItem(bannerName);

function PackageExpire({ setIsBannerShown }) {
  const { remainingDaysNum, remainingConvsNum } = useSelector(mapState);
  const bannerName = 'packageExpireBanner';
  const days = remainingDaysNum;
  const status = getBannerStatusFromLocalStorage(bannerName);

  const { getTranslation } = useTranslation('NOTIFS_MESSAGES');
  const { t } = getTranslation();

  const shouldPackageBannerAppear = !!(
    days !== '' &&
    +days <= 5 &&
    status === null
  );

  const shouldRemainingConvsBannerAppear = !!(
    remainingConvsNum !== '' &&
    +remainingConvsNum < 50 &&
    status === null
  );

  const getPackageExpireBannerText = () => {
    const leftedDaysNotif = replaceKeyWithValue(
      t('PACKAGE_EXPIRE_SOON_BANNER_TEXT'),
      'days',
      days
    );

    if (+days === 0) return t('EXPIRE_BANNER_ENDED_CREDIT');
    return leftedDaysNotif;
  };

  const getRemainingConvsEndingBannerText = () => {
    const notifText = replaceKeyWithValue(
      t('REMAINING_CONVS_ENDING_BANNER_TEXT'),
      'convs',
      remainingConvsNum
    );

    if (+remainingConvsNum === 0) return t('REMAINING_CONVS_ENDED_BANNER_TEXT');
    return notifText;
  };

  const getExpireAlertText = () => {
    if (shouldPackageBannerAppear) {
      return getPackageExpireBannerText();
    }

    return getRemainingConvsEndingBannerText();
  };

  const shouldBannerAppear =
    shouldPackageBannerAppear || shouldRemainingConvsBannerAppear;

  const handleClose = () => {
    setIsBannerShown(false);
    localStorage.setItem(bannerName, false);
  };

  useEffect(() => {
    if (shouldBannerAppear) setIsBannerShown(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [days, remainingConvsNum]);

  if (shouldBannerAppear) {
    return (
      <BannerMessage
        name={bannerName}
        text={getExpireAlertText(days)}
        type='alert'
        onClose={handleClose}
      />
    );
  }

  return null;
}

export default PackageExpire;
